import { createAsyncThunk } from "@reduxjs/toolkit";
import { KeysManager } from "app/data/services";
import { toast, types } from "@vilocnv/allsetra-core";

export const getAccountKeysByQueryThunk = createAsyncThunk(
  "accounts/getAccountKeysByQueryThunk",
  async ({
    params,
    accountId
  }: {
    params: types.IRecordsAggregationBody;
    accountId: string;
  }) => {
    try {
      const response = await KeysManager.getAccountKeysByQuery(
        params,
        accountId
      );

      if (response.status === 200) {
        return response.data;
      } else {
        toast.error("Server side issue occured.");
      }
    } catch (e: any) {
      console.error(e);
      throw new Error(e);
    }
  }
);

export const getAvailableKeysByAccountThunk = createAsyncThunk(
  "accounts/getAvailableKeysByAccountThunk",
  async (accountId: string) => {
    try {
      const response = await KeysManager.getAvailableKeysByAccount(accountId);

      if (response.status === 200) {
        return response.data;
      }

      return response;
    } catch (e: any) {
      console.error(e);
      throw new Error(e);
    }
  }
);

export const createKeysThunk = createAsyncThunk(
  "accounts/createKeysThunk",
  async ({ accountId, data }: any) => {
    try {
      const response = await KeysManager.createKeys(accountId, data);

      if (response.status === 202) {
        toast.success("Create keys request is being processed by the backend.");
      } else {
        toast.error("Server side issue occured.");
      }

      return response;
    } catch (e: any) {
      console.error(e);
      throw new Error(e);
    }
  }
);

export const deactivateKeyThunk = createAsyncThunk(
  "accounts/deactivateKeyThunk",
  async ({ accountId, keyId }: any) => {
    try {
      const response = await KeysManager.deactivateKey(accountId, keyId);

      if (response.status === 202) {
        toast.success(
          "Deactivate key request is being processed by the backend."
        );
      } else {
        toast.error("Server side issue occured.");
      }

      return response;
    } catch (e: any) {
      console.error(e);
      throw new Error(e);
    }
  }
);

export const activateKeyThunk = createAsyncThunk(
  "accounts/activateKeyThunk",
  async ({ accountId, keyId, label, assignedUser }: any) => {
    try {
      const payload: any = {};
      if (assignedUser) {
        payload.assignedUser = assignedUser;
      } else if (label) {
        payload.label = label;
      }
      const response = await KeysManager.activateKey(accountId, keyId, payload);

      if (response.status === 202) {
        toast.success(
          "Activate key request is being processed by the backend."
        );
      } else {
        toast.error("Server side issue occured.");
      }

      return response;
    } catch (e: any) {
      console.error(e);
      throw new Error(e);
    }
  }
);

export const getAllKeysByAccountThunk = createAsyncThunk(
  "accounts/getAllKeysByAccountThunk",
  async (accountId: string) => {
    try {
      const response = await KeysManager.getAllKeysByAccount(accountId);

      if (response.status === 200) {
        return response.data;
      }

      return response;
    } catch (e: any) {
      console.error(e);
      throw new Error(e);
    }
  }
);
